import { render, staticRenderFns } from "./customerIdentity.vue?vue&type=template&id=128c42bc"
import script from "./customerIdentity.vue?vue&type=script&lang=js"
export * from "./customerIdentity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports